import React from "react";
import * as S from "./styles";
export var TabItem = function TabItem(_ref) {
  var e = _ref.ariaControls,
      o = _ref.children,
      t = _ref.className,
      l = _ref.tabIndex,
      a = _ref.handleClick,
      r = _ref.handleMouseEnter,
      n = _ref.handleMouseLeave,
      c = _ref.opacity,
      i = _ref.isScrollable,
      d = _ref.isScrolling,
      s = _ref.isRound,
      u = _ref.isSelected,
      v = _ref.colorConfig;
  return React.createElement(S.Item, {
    key: "tab-".concat(l),
    "data-index": "tab-menu-tab-".concat(l),
    className: t,
    role: "tab",
    "aria-controls": e,
    "aria-selected": !0,
    tabIndex: "0",
    "data-testid": "tab-menu-tab-".concat(l),
    style: {
      opacity: c
    },
    onKeyUp: function onKeyUp(e) {
      var o = e.currentTarget;
      "Enter" === e.key && a(l, o);
    },
    onClick: function onClick(e) {
      var o = e.currentTarget;
      a(l, o);
    },
    onMouseEnter: function onMouseEnter() {
      return r(l);
    },
    onMouseLeave: function onMouseLeave() {
      return n();
    },
    isScrollable: i,
    isScrolling: d,
    isRound: s,
    isSelected: u,
    inactiveBackground: null == v ? void 0 : v.inactiveBackground,
    inactiveBorderColor: null == v ? void 0 : v.inactiveBorderColor,
    inactiveTextColor: null == v ? void 0 : v.inactiveTextColor,
    selectedBackground: null == v ? void 0 : v.selectedBackground,
    selectedBorderColor: null == v ? void 0 : v.selectedBorderColor,
    selectedTextColor: null == v ? void 0 : v.selectedTextColor
  }, o);
};
export default TabItem;